module.exports = __webpack_public_path__ + "img/menucn_4_2.d125ea5d.svg";